export default "__VITE_ASSET__BYe4ARcB__"